import type { Module } from '@/types/modules'
import { NestUserRole } from '@/types/user'

export type SubItem = {
  name: string
  url: string
  module?: number
  roles?: NestUserRole[]
}

export type MenuItem = {
  name: string
  subItems?: SubItem[] | undefined
  module?: number
  roles?: NestUserRole[]
  url?: string
}

export const modules: Module[] = [
  {
    id: 1,
    displayName: 'Projects',
  },
  {
    id: 2,
    displayName: 'Shipments',
  },
  {
    id: 3,
    displayName: 'Templates',
  },
  {
    id: 4,
    displayName: 'Users',
  },
] as const

export const menuItems: MenuItem[] = [
  { name: 'Projecten', url: '/projects', module: 1 },
  { name: 'Zendingen', url: '/shipments', module: 2 },
  { name: 'Sjablonen', url: '/templates', module: 3 },
  {
    name: 'Beheer',
    subItems: [
      {
        name: 'Gebruikers',
        url: '/users',
        module: 4,
        roles: [NestUserRole.ADMIN, NestUserRole.OWNER],
      },
      { name: 'Organisatie', url: '/customer', roles: [NestUserRole.ADMIN, NestUserRole.OWNER] },
    ],
  },
  {
    name: 'LZP',
    subItems: [{ name: 'Sub Apps', url: '/sub-apps', roles: [NestUserRole.ADMIN] }],
  },
]
